import React from 'react';
import { Box, Typography } from '@mui/material';

/** Spójne z AddProjectForm / drawerem „Nowy kosztorys”: etykieta nad polem + obramowanie / hover / focus */
export const textFieldSx = {
  '& .MuiInputLabel-root': {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#2D2D32',
  },
  '& .MuiOutlinedInput-root': {
    height: 32,
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d4d9' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#595966' },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
  '& .MuiOutlinedInput-root.Mui-focused': { boxShadow: 'none', outline: 'none' },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d4d9' },
  '& .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#595966' },
  '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
  '& .MuiInputBase-input': {
    padding: '8px 12px',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '16px',
    color: '#2D2D32',
  },
  '& .MuiFormHelperText-root': { ml: 0 },
} as const;

export const multilineFieldSx = {
  ...textFieldSx,
  '& .MuiOutlinedInput-root': {
    height: 84,
    backgroundColor: '#fff',
    borderRadius: '4px',
    alignItems: 'flex-start',
  },
  '& .MuiInputBase-input': { padding: 0 },
  '& .MuiOutlinedInput-input': { padding: 0 },
} as const;

export const FieldLabel: React.FC<{ text: string; required?: boolean }> = ({ text, required }) => (
  <Typography sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: '#2D2D32', mb: 0.5 }}>
    {text}
    {required && (
      <Box component="span" sx={{ color: '#d32f2f' }}>
        {' '}
        *
      </Box>
    )}
  </Typography>
);

export const sectionTitleSx = {
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 600,
  fontSize: '13px',
  color: '#5F6368',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  mb: 1.5,
  mt: 0,
} as const;
